var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2502 37.0007C53.0643 37.0007 58.5835 31.4815 58.5835 24.6673C58.5835 17.8532 53.0643 12.334 46.2502 12.334C39.436 12.334 33.9168 17.8532 33.9168 24.6673C33.9168 31.4815 39.436 37.0007 46.2502 37.0007ZM18.5002 30.834V21.584H12.3335V30.834H3.0835V37.0007H12.3335V46.2506H18.5002V37.0007H27.7502V30.834H18.5002ZM46.2502 43.1673C38.0177 43.1673 21.5835 47.299 21.5835 55.5006V61.6673H70.9168V55.5006C70.9168 47.299 54.4827 43.1673 46.2502 43.1673Z",
    fill: "#BBEE67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFree);
export default __webpack_public_path__ + "static/media/free.531a0728090c2e68c8eba2e623590a69.svg";
export { ForwardRef as ReactComponent };